import type { App, Plugin } from "vue";
import * as CKEditorVue from "@ckeditor/ckeditor5-vue/dist/ckeditor.js";

type CKEditorPluginType = Plugin & {
  component?: unknown;
};

const resolveCKEditorPlugin = (moduleValue: unknown): CKEditorPluginType | null => {
  const candidate = moduleValue as Record<string, unknown>;

  if (typeof candidate.install === "function") {
    return candidate as CKEditorPluginType;
  }

  if (candidate.default) {
    return resolveCKEditorPlugin(candidate.default);
  }

  return null;
};

const ckeditorPlugin = resolveCKEditorPlugin(CKEditorVue);

export default ckeditorPlugin;

export const registerCKEditor = (app: App) => {
  if (!ckeditorPlugin) {
    console.warn("@ckeditor/ckeditor5-vue plugin could not be loaded.");
    return;
  }

  app.use(ckeditorPlugin);

  if (ckeditorPlugin.component) {
    app.component("ckeditor", ckeditorPlugin.component as never);
  }
};
